import { skeletonStyle } from "@repo/ui/Skeletons/skeletons";
import type { FC } from "react";
import { useGetKnowledgeBaseAttachmentsQuery } from "../../api/entities/knowledgeBase.js";

export interface KnowledgeBaseDocumentTitleProps {
  knowledgeBaseId: string;
  attachmentId: string;
}

export const KnowledgeBaseDocumentTitle: FC<KnowledgeBaseDocumentTitleProps> = (
  props,
) => {
  const { data: attachments, isLoading } = useGetKnowledgeBaseAttachmentsQuery(
    props.knowledgeBaseId,
  );
  const attachment = attachments?.find(
    (attachment) => attachment.id === props.attachmentId,
  );

  if (attachment === undefined && isLoading) {
    return (
      <span
        className={skeletonStyle({
          className: "inline-block h-4 w-24 align-middle",
        })}
      ></span>
    );
  }

  if (attachment === undefined) {
    return <span>Unknown article</span>;
  }

  return <span>{attachment.title}</span>;
};
